import { defineStore } from 'pinia'
import {  type AddonGroup, type AddonItem, type SpecGroup, type SpecItem } from '../../types'

interface AddonState {
  addonList: AddonGroup[]
}

export const useAddon = defineStore('addon', {
  state: (): AddonState => {
    return {
      addonList: []
    }
  },
  getters: {
    getSelectedList(): AddonGroup[] {
      return this.addonList
    },
    isCompleted(): boolean {
      return this.addonList.every(f => f.selectedItem)
    }
  },
  actions: {
    dataFill(values: AddonGroup[]): void {
      this.addonList.splice(0)
      this.addonList.push(...values)
      this.addonList.forEach(f=>{
        if (f.values.length===1){
          f.selectedItem = f.values[0]
        }
      })
    },

    setSelectedValue(name: string, val?: AddonItem): void {
      const item = this.addonList.find((f) => f.name === name)
      if (item) {
        item.selectedItem= val
      }
    }
  }
})
